import { Emitter } from "@core/events/emitter";
import type { HoverChangedEvent, IHoverModel } from "./IHoverModel";

export class HoverModel implements IHoverModel {
  readonly onChanged = new Emitter<HoverChangedEvent>();
  private m_hoveredId: string | null = null;

  get hoveredId(): string | null {
    return this.m_hoveredId;
  }

  setHovered(snapshotId: string | null): void {
    if (this.m_hoveredId === snapshotId) return;
    this.m_hoveredId = snapshotId;
    this.onChanged.emit({ snapshotId });
  }

  clear(): void {
    this.setHovered(null);
  }
}
